import { Box } from '@chakra-ui/react';
import React from 'react';

import { colors } from 'packages/common-frontend/colors';

type SettingStickyHeaderProps = {
  children: React.ReactNode;
};
export const SettingStickyHeader = ({ children }: SettingStickyHeaderProps) => {
  return (
    <Box
      position="sticky"
      top="0"
      zIndex="sticky"
      padding="21px"
      backgroundColor={colors.background[50]}
      boxShadow="0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px -1px rgba(0, 0, 0, 0.10)"
      maxHeight="80vh"
    >
      {/* Chakra doesn't natively support flex-gap */}
      {children}
    </Box>
  );
};
